import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Navbar } from './Navbar';

const ProtectedRoute = ({ element, requiredStep }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const completedSteps = JSON.parse(localStorage.getItem('completedSteps')) || [];

        // Simulate a small delay for checking the condition
        const timer = setTimeout(() => {
            if (completedSteps.includes(requiredStep)) {
                setIsAuthorized(true);
            } else {
                toast.error(`Please complete the required step: ${requiredStep}`);
                setIsAuthorized(false);
            }
            setIsLoading(false);
        }, 500); // Delay to display loader

        return () => clearTimeout(timer); // Cleanup timeout
    }, [requiredStep]);

    if (isLoading) {
        // Display the loader while checking the step
        return (
            <>
            <Navbar />
            <div className="flex items-center justify-center h-[90vh] bg-gray-100">
                <div className="loader border-t-4 border-blue-500 rounded-full w-12 h-12 animate-spin"></div>
                <span className="ml-4 text-gray-700">Checking access...</span>
            </div>
            </>
        );
    }

    // Redirect to home if not authorized
    if (!isAuthorized) {
        return <Navigate to="/" />;
    }

    // Render the protected element if authorized
    return element;
};

export default ProtectedRoute;
